/*!
 * Habitat Advanced Nutrient Calculator — storefront widget (thin client).
 *
 * The UI lives here; ALL chemistry (weighted-NNLS solver, salt optimizer, EC
 * models, exact salt compositions) runs server-side in the calculation API,
 * reached same-origin through the Shopify App Proxy (default: POST /apps/calc).
 * Override the endpoint with data-calc-endpoint="..." on the mount div or
 * window.HABITAT_CALC = { endpoint: "..." } (used by the local dev harness).
 *
 * Drop-in usage (e.g. Shopify):
 *   <div id="hydrobuddy"></div>
 *   <script src="{{ 'hydrobuddy.js' | asset_url }}"></script>
 * The widget auto-mounts into #hydrobuddy (or any <div data-hydrobuddy>).
 * No persistence — recipes are exported, never saved.
 */
(function () {
  "use strict";

  /* ------------------------------------------------------------------ *
   *  Embedded data (salts / formulations / water presets)              *
   *  Injected at build time — see app/_data.json.                      *
   * ------------------------------------------------------------------ */
  var HB_DATA = {"salts":[{"name":"Ammonium Chloride","formula":"NH4Cl","isLiquid":0,"supplies":["nNH4","Cl"]},{"name":"Ammonium Dibasic Phosphate","formula":"(NH4)2HPO4","isLiquid":0,"supplies":["nNH4","P"]},{"name":"Ammonium Monobasic Phosphate","formula":"(NH4)H2PO4","isLiquid":0,"supplies":["nNH4","P"]},{"name":"Ammonium Nitrate","formula":"NH4NO3","isLiquid":0,"supplies":["nNO3","nNH4"]},{"name":"Ammonium Nitrate (liquid, 18% N)","formula":"NH4NO3 (aq)","isLiquid":1,"supplies":["nNO3","nNH4"]},{"name":"Ammonium Sulfate","formula":"(NH4)2SO4","isLiquid":0,"supplies":["nNH4","S"]},{"name":"Boric Acid","formula":"H3BO3","isLiquid":0,"supplies":["B"]},{"name":"Calcium Carbonate","formula":"CaCO3","isLiquid":0,"supplies":["Ca"]},{"name":"Calcium Monobasic Phosphate","formula":"Ca(H2PO4)2.H2O","isLiquid":0,"supplies":["P","Ca"]},{"name":"Calcium Nitrate (ag grade)","formula":"Ca(NO3)2","isLiquid":0,"supplies":["nNO3","nNH4","Ca"]},{"name":"Calcium Sulfate (Dihydrate)","formula":"CaSO4.2H2O","isLiquid":0,"supplies":["Ca","S"]},{"name":"CH - micro","formula":"Ch micro","isLiquid":0,"supplies":["Fe","Mn","Zn","B","Cu","Mo"]},{"name":"Copper EDTA","formula":"CuEDTA","isLiquid":0,"supplies":["Cu"]},{"name":"Copper Nitrate (Hexahydrate)","formula":"Cu(NO3)2.6H2O","isLiquid":0,"supplies":["nNO3","Cu"]},{"name":"Copper Sulfate (pentahydrate)","formula":"CuSO4.5H2O","isLiquid":0,"supplies":["S","Cu"]},{"name":"Iron DTPA","formula":"FeDTPA","isLiquid":0,"supplies":["Fe"]},{"name":"Iron EDDHA","formula":"FeEDDHA","isLiquid":0,"supplies":["Fe"]},{"name":"Iron EDTA","formula":"Fe(EDTA)","isLiquid":0,"supplies":["Fe"]},{"name":"Iron II Sulfate (Hepahydrate)","formula":"FeSO4.7H2O","isLiquid":0,"supplies":["S","Fe"]},{"name":"Magnesium Carbonate","formula":"MgCO3","isLiquid":0,"supplies":["Mg"]},{"name":"Magnesium Sulfate (Heptahydrate)","formula":"MgSO4.7H2O","isLiquid":0,"supplies":["Mg","S"]},{"name":"Mg Nitrate","formula":"Mg(NO3)2","isLiquid":0,"supplies":["nNO3","Mg"]},{"name":"Mn EDTA","formula":"MnEDTA","isLiquid":0,"supplies":["Mn"]},{"name":"Phosphoric Acid (75%)","formula":"H3PO4","isLiquid":1,"supplies":["P"]},{"name":"Potassium Carbonate","formula":"K2CO3","isLiquid":0,"supplies":["K"]},{"name":"Potassium Chloride","formula":"KCl","isLiquid":0,"supplies":["K","Cl"]},{"name":"Potassium Citrate","formula":"C6H5K3O7","isLiquid":0,"supplies":["K"]},{"name":"Potassium Dibasic Phosphate","formula":"K2HPO4","isLiquid":0,"supplies":["P","K"]},{"name":"Potassium Monobasic Phosphate","formula":"KH2PO4","isLiquid":0,"supplies":["P","K"]},{"name":"Potassium Nitrate","formula":"KNO3","isLiquid":0,"supplies":["nNO3","K"]},{"name":"Potassium Sulfate","formula":"K2SO4","isLiquid":0,"supplies":["K","S"]},{"name":"Sodium Borate (Decahydrate) (borax)","formula":"Na2B4O7.10H2O","isLiquid":0,"supplies":["B","Na"]},{"name":"Sodium Molybdate (Dihydrate)","formula":"Na2MoO4.2H2O","isLiquid":0,"supplies":["Mo","Na"]},{"name":"Sodium Nitrate","formula":"NaNO3","isLiquid":0,"supplies":["nNO3","Fe","Na"]},{"name":"Zinc Nitrate (Hexahydrate)","formula":"Zn(NO3)2.6H2O","isLiquid":0,"supplies":["nNO3","Zn"]},{"name":"Zinc Sulfate (Monohydrate)","formula":"ZnSO4.H2O","isLiquid":0,"supplies":["S","Zn"]},{"name":"Zn EDTA","formula":"ZnEDTA","isLiquid":0,"supplies":["Zn"]}],"formulations":[{"name":"Chilli (maximumyield)","units":"ppm","targets":{"nNO3":320,"nNH4":0,"P":103,"K":364,"Mg":96,"Ca":330,"S":174,"Fe":4.9,"Mn":1.97,"Zn":0.25,"B":0.7,"Cu":0.07,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Cucumber (Howard Resh)","units":"ppm","targets":{"nNO3":140,"nNH4":0,"P":50,"K":350,"Mg":50,"Ca":200,"S":150,"Fe":3,"Mn":0.8,"Zn":0.1,"B":0.3,"Cu":0.07,"Si":0,"Mo":0.03,"Na":0,"Cl":0}},{"name":"Generic Bloom (maximumyield)","units":"ppm","targets":{"nNO3":130,"nNH4":0,"P":60,"K":300,"Mg":30,"Ca":100,"S":60,"Fe":2,"Mn":0.5,"Zn":0.1,"B":0.5,"Cu":0.05,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Generic Dry Season (Howard Resh)","units":"ppm","targets":{"nNO3":177,"nNH4":53,"P":60,"K":200,"Mg":36,"Ca":250,"S":129,"Fe":5,"Mn":0.5,"Zn":0.05,"B":0.5,"Cu":0.03,"Si":0,"Mo":0.02,"Na":0,"Cl":0}},{"name":"Generic for Berries (Growing Edge)","units":"ppm","targets":{"nNO3":207,"nNH4":0,"P":55,"K":289,"Mg":38,"Ca":155,"S":51,"Fe":6.8,"Mn":1.97,"Zn":0.25,"B":0.7,"Cu":0.07,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Generic Grow (maximumyield)","units":"ppm","targets":{"nNO3":160,"nNH4":0,"P":30,"K":230,"Mg":30,"Ca":100,"S":60,"Fe":2,"Mn":0.5,"Zn":0.1,"B":0.5,"Cu":0.05,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Generic Wet Season (Howard Resh)","units":"ppm","targets":{"nNO3":115,"nNH4":32,"P":50,"K":150,"Mg":50,"Ca":150,"S":50,"Fe":5,"Mn":0.5,"Zn":0.05,"B":0.5,"Cu":0.03,"Si":0,"Mo":0.02,"Na":0,"Cl":0}},{"name":"Hoagland solution","units":"ppm","targets":{"nNO3":210,"nNH4":0,"P":31,"K":235,"Mg":49,"Ca":200,"S":64,"Fe":2.9,"Mn":0.5,"Zn":0.05,"B":0.5,"Cu":0.02,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Jack's Hydroponic (5-12-26) plus Ca-Nitrate","units":"ppm","targets":{"nNO3":150,"nNH4":0,"P":39,"K":162,"Mg":47,"Ca":139,"S":50,"Fe":2.3,"Mn":0.38,"Zn":0.11,"B":0.38,"Cu":0.113,"Si":0,"Mo":0.075,"Na":0,"Cl":0}},{"name":"Lettuce 2 (Howard Resh)","units":"ppm","targets":{"nNO3":165,"nNH4":15,"P":50,"K":210,"Mg":45,"Ca":190,"S":113,"Fe":4,"Mn":0.5,"Zn":0.1,"B":0.5,"Cu":0.1,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Lettuce General (Howard Resh)","units":"ppm","targets":{"nNO3":165,"nNH4":15,"P":50,"K":210,"Mg":45,"Ca":190,"S":65,"Fe":4,"Mn":0.5,"Zn":0.1,"B":0.5,"Cu":0.1,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Melons (Douglas Peckenpaugh)","units":"ppm","targets":{"nNO3":215,"nNH4":0,"P":86,"K":343,"Mg":85,"Ca":175,"S":113,"Fe":6.8,"Mn":1.97,"Zn":0.25,"B":0.7,"Cu":0.07,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Modified Sonneveld","units":"ppm","targets":{"nNO3":150,"nNH4":0,"P":31,"K":210,"Mg":24,"Ca":90,"S":50,"Fe":1,"Mn":0.25,"Zn":0.13,"B":0.16,"Cu":0.023,"Si":0,"Mo":0.024,"Na":0,"Cl":0}},{"name":"Pepper (Howard Resh)","units":"ppm","targets":{"nNO3":190,"nNH4":18,"P":40,"K":340,"Mg":50,"Ca":170,"S":120,"Fe":5,"Mn":0.55,"Zn":0.33,"B":0.33,"Cu":0.05,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Rice (Douglas Peckenpaugh)","units":"ppm","targets":{"nNO3":249,"nNH4":0,"P":58,"K":80,"Mg":65,"Ca":317,"S":87,"Fe":5,"Mn":0.8,"Zn":0.4,"B":0.7,"Cu":0.07,"Si":100,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Strawberry - Inert Substrate (Nutrient Solutions for Greenhouse Crops v5, fertigation)","units":"ppm","targets":{"nNO3":168,"nNH4":14,"P":31,"K":188,"Mg":36,"Ca":144,"S":48,"Fe":1.68,"Mn":0.55,"Zn":0.458,"B":0.108,"Cu":0.048,"Si":0,"Mo":0.048,"Na":0,"Cl":0}},{"name":"Strawberry - Organic Substrate (Nutrient Solutions for Greenhouse Crops v5, fertigation)","units":"ppm","targets":{"nNO3":165,"nNH4":11,"P":31,"K":176,"Mg":36,"Ca":150,"S":48,"Fe":1.68,"Mn":0.55,"Zn":0.458,"B":0.108,"Cu":0.048,"Si":0,"Mo":0.048,"Na":0,"Cl":0}},{"name":"Strawberry Drip Irrigation (schundler.com)","units":"ppm","targets":{"nNO3":80,"nNH4":0,"P":45,"K":100,"Mg":50,"Ca":200,"S":180,"Fe":3,"Mn":0.5,"Zn":0.5,"B":0.5,"Cu":0.05,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Strawberry Fruiting (growing edge)","units":"ppm","targets":{"nNO3":128,"nNH4":0,"P":58,"K":211,"Mg":40,"Ca":104,"S":54,"Fe":5,"Mn":2,"Zn":0.25,"B":0.7,"Cu":0.07,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Tomato (Howard Resh)","units":"ppm","targets":{"nNO3":140,"nNH4":0,"P":50,"K":352,"Mg":50,"Ca":180,"S":168,"Fe":5,"Mn":0.8,"Zn":0.1,"B":0.3,"Cu":0.07,"Si":0,"Mo":0.03,"Na":0,"Cl":0}},{"name":"Tomato Stage.1 - 10-14 days (Howard Resh)","units":"ppm","targets":{"nNO3":100,"nNH4":0,"P":40,"K":200,"Mg":20,"Ca":100,"S":53,"Fe":3,"Mn":0.8,"Zn":0.1,"B":0.3,"Cu":0.07,"Si":0,"Mo":0.03,"Na":0,"Cl":0}},{"name":"Tomato Stage.2 - first cluster (Howard Resh)","units":"ppm","targets":{"nNO3":130,"nNH4":0,"P":55,"K":300,"Mg":33,"Ca":150,"S":109,"Fe":3,"Mn":0.8,"Zn":0.1,"B":0.3,"Cu":0.07,"Si":0,"Mo":0.03,"Na":0,"Cl":0}},{"name":"Tomato Stage.3 - to plant maturity (Howard Resh)","units":"ppm","targets":{"nNO3":180,"nNH4":0,"P":65,"K":400,"Mg":45,"Ca":400,"S":144,"Fe":3,"Mn":0.8,"Zn":0.1,"B":0.3,"Cu":0.07,"Si":0,"Mo":0.03,"Na":0,"Cl":0}},{"name":"Tomatoes - Fourth Cluster (U of Florida)","units":"ppm","targets":{"nNO3":120,"nNH4":0,"P":50,"K":150,"Mg":50,"Ca":150,"S":60,"Fe":2.8,"Mn":0.8,"Zn":0.3,"B":0.7,"Cu":0.2,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Tomatoes - Second Cluster (U of Florida)","units":"ppm","targets":{"nNO3":80,"nNH4":0,"P":50,"K":120,"Mg":40,"Ca":150,"S":50,"Fe":2.8,"Mn":0.8,"Zn":0.3,"B":0.7,"Cu":0.2,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Tomatoes - Third Cluster (U of Florida)","units":"ppm","targets":{"nNO3":100,"nNH4":0,"P":50,"K":150,"Mg":40,"Ca":150,"S":50,"Fe":2.8,"Mn":0.8,"Zn":0.3,"B":0.7,"Cu":0.2,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Tomatoes - till First Cluster (U of Florida)","units":"ppm","targets":{"nNO3":70,"nNH4":0,"P":50,"K":120,"Mg":40,"Ca":150,"S":50,"Fe":2.8,"Mn":0.8,"Zn":0.3,"B":0.7,"Cu":0.2,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Tomatoes - to termination (U of Florida)","units":"ppm","targets":{"nNO3":150,"nNH4":0,"P":50,"K":200,"Mg":50,"Ca":150,"S":60,"Fe":2.8,"Mn":0.8,"Zn":0.3,"B":0.7,"Cu":0.2,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"Tropical Lettuce (Douglas Peckenpaugh)","units":"ppm","targets":{"nNO3":190,"nNH4":0,"P":25,"K":98,"Mg":25,"Ca":216,"S":33,"Fe":4.9,"Mn":1.97,"Zn":0.25,"B":0.7,"Cu":0.07,"Si":0,"Mo":0.05,"Na":0,"Cl":0}},{"name":"UA CEAC Recipe","units":"ppm","targets":{"nNO3":189,"nNH4":0,"P":39,"K":341,"Mg":48,"Ca":170,"S":50,"Fe":2,"Mn":0.55,"Zn":0.33,"B":0.28,"Cu":0.05,"Si":0,"Mo":0.05,"Na":0,"Cl":0}}]};

  /* ------------------------------------------------------------------ *
   *  Element model (display-side only)                                  *
   *  Internal 16-element order matches the engine. MM = molar mass      *
   *  (for mmol/L <-> ppm display conversion). All solver/EC data lives  *
   *  server-side in the calculation API.                                *
   * ------------------------------------------------------------------ */
  var ELEMENTS = [
    { key: "nNO3", label: "N (NO₃⁻)",     MM: 14.007, group: "macro" },
    { key: "nNH4", label: "N (NH₄⁺)",     MM: 14.007, group: "macro" },
    { key: "P",    label: "P (H₂PO₄⁻)",   MM: 30.974, group: "macro" },
    { key: "K",    label: "K (K⁺)",       MM: 39.098, group: "macro" },
    { key: "Mg",   label: "Mg (Mg²⁺)",    MM: 24.305, group: "macro" },
    { key: "Ca",   label: "Ca (Ca²⁺)",    MM: 40.078, group: "macro" },
    { key: "S",    label: "S (SO₄²⁻)",    MM: 32.066, group: "macro" },
    { key: "Fe",   label: "Fe (Fe²⁺/³⁺)", MM: 55.845, group: "micro" },
    { key: "Mn",   label: "Mn (Mn²⁺)",    MM: 54.938, group: "micro" },
    { key: "Zn",   label: "Zn (Zn²⁺)",    MM: 65.409, group: "micro" },
    { key: "B",    label: "B (BO₃³⁻)",    MM: 10.811, group: "micro" },
    { key: "Cu",   label: "Cu (Cu²⁺)",    MM: 63.546, group: "micro" },
    { key: "Si",   label: "Si (H₄SiO₄)",  MM: 28.086, group: "micro" },
    { key: "Mo",   label: "Mo (MoO₄²⁻)",  MM: 95.94,  group: "micro" },
    { key: "Na",   label: "Na (Na⁺)",     MM: 22.990, group: "micro" },
    { key: "Cl",   label: "Cl (Cl⁻)",     MM: 35.453, group: "micro" }
  ];

  // Oxide <-> element mass factors (matches original constants)
  var SIO2_TO_SI = 0.4684;   // Si target given as SiO2 -> Si
  var P_TO_P2O5 = 2.2915;
  var K_TO_K2O = 1.2047;

  var UNITS = {
    mmol: { label: "mmol/L",     factor: function (e) { return e.MM; } },
    ppm:  { label: "ppm (mg/L)", factor: function (e) { return 1; } }
  };

  // Salt name -> Habitat Hydroponics product URL. Salts that appear here show an
  // "In stock ↗" link in the salt list and a "Buy from Habitat ↗" link in the recipe.
  // Extend this map as more of the calculator's salts are stocked as products.
  var PRODUCT_LINKS = {
    "Calcium Nitrate (ag grade)": "https://habitathydroponics.com/products/calcium-nitrate-hydroponic-fertilizer-1kg-or-25kg",
    "Potassium Nitrate": "https://habitathydroponics.com/products/omni-k%E2%84%A2-potassium-nitrate-water-soluble-fertilizer-for-hydroponics"
  };


  // Crop quick-picks for the "Start recipe" grid. Each is a one-click shortcut to
  // an existing formulation (by name) — the exact-recipe dropdown covers the rest.
  var CROPS_QUICK = [
    { name: "Lettuce",     icon: "🥬", recipe: "Lettuce General (Howard Resh)" },
    { name: "Basil",       icon: "🌿", recipe: "Lettuce 2 (Howard Resh)" },
    { name: "Kale",        icon: "🥬", recipe: "Lettuce General (Howard Resh)" },
    { name: "Microgreens", icon: "🌱", recipe: "Generic Grow (maximumyield)" },
    { name: "Herbs",       icon: "🪴", recipe: "Lettuce 2 (Howard Resh)" },
    { name: "Cucumber",    icon: "🥒", recipe: "Cucumber (Howard Resh)" },
    { name: "Tomato",      icon: "🍅", recipe: "Tomato (Howard Resh)" },
    { name: "Pepper",      icon: "🌶️", recipe: "Pepper (Howard Resh)" },
    { name: "Strawberry",  icon: "🍓", recipe: "Strawberry - Organic Substrate (Nutrient Solutions for Greenhouse Crops v5, fertigation)" }
  ];

  // Named source-water presets (ppm). Rain/RO is pure water (the safe default).
  // NOTE: the Windhoek & borehole figures are PLACEHOLDER ESTIMATES — replace with
  // real water-report numbers. Only elements the solver tracks are listed.
  var WATER_SOURCES = [
    { name: "Rain water / RO (pure)",         est: false, comp: {} },
    { name: "Windhoek municipal (estimate)",  est: true,  comp: { Ca: 50, Mg: 15, Na: 40, S: 30, Cl: 60 } },
    { name: "Borehole — hard (estimate)",     est: true,  comp: { Ca: 90, Mg: 30, Na: 60, S: 50, Cl: 90 } }
  ];

  // Agronomic tolerance band (min%, max% deviation from target) per element.
  // These encode what a consultant would call "close enough": P/N/K/Ca matter
  // tightly; S is very forgiving (plants tolerate wide sulfate ranges); micros
  // sit in between. Used for the Off-column colour AND the optimizer's score.
  function bandFor(key) {
    if (key === "P" || key === "nNO3" || key === "K" || key === "Ca") return [-10, 15];
    if (key === "nNH4") return [-25, 25];
    if (key === "Mg") return [-15, 20];
    if (key === "S") return [-30, 60];
    return [-20, 30]; // micros + Na/Cl/Si
  }

  // Key nutrient ratios from achieved ppm. N:P:K uses the fertiliser-label
  // convention (N : P₂O₅ : K₂O) — same basis as a bag grade like 5-12-26.
  function ratios(achieved) {
    var N = (achieved.nNO3 || 0) + (achieved.nNH4 || 0);
    function r(a, b) { return b > 0 ? (a / b) : 0; }
    return {
      "N:P:K": [1, round(r((achieved.P || 0) * P_TO_P2O5, N), 2), round(r((achieved.K || 0) * K_TO_K2O, N), 2)],
      "K:Ca": round(r(achieved.K, achieved.Ca), 2),
      "Ca:Mg": round(r(achieved.Ca, achieved.Mg), 2),
      "NO₃:NH₄": round(r(achieved.nNO3, achieved.nNH4), 2)
    };
  }

  function round(n, p) { var m = Math.pow(10, p); return Math.round(n * m) / m; }

  // Convert the user-entered target (in `unit`, with Si-as-SiO2 handling) to ppm.
  function targetToPpm(el, value, unit, siAsSiO2) {
    var f = UNITS[unit].factor(el);
    var ppm = f * value;
    if (el.key === "Si" && siAsSiO2) ppm = SIO2_TO_SI * f * value;
    return ppm;
  }
  // Convert an achieved ppm back to display units.
  function ppmToDisplay(el, ppm, unit, siAsSiO2) {
    var f = UNITS[unit].factor(el);
    var v = ppm / f;
    if (el.key === "Si" && siAsSiO2) v = v / SIO2_TO_SI;
    return v;
  }

  /* ================================================================== *
   *  UI                                                                *
   * ================================================================== */

  var STYLE = "\n\
:host{all:initial;display:block;width:100%}\n\
*{box-sizing:border-box}\n\
.hb{font-family:var(--font-body--family),'Montserrat',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;\
color:var(--ink);line-height:1.5;width:100%;max-width:1040px;margin:0 auto;padding:0;overflow-x:hidden;\
-webkit-font-smoothing:antialiased;\
--green:#375d31;--green-dark:#2b4a26;--green-tint:#e7efe4;--ink:#1e2a1c;--muted:#5f6b5b;\
--line:#e3e8e0;--soft:#f4f7f2;--page:#eef2ee;--danger:#c0392b;--warn-bg:#fbf3e2;--warn-fg:#7a4f10;\
--hb-bg:#fff;--hb-fg:var(--ink);--hb-muted:var(--muted);--hb-line:var(--line);--hb-accent:var(--green);\
--hb-accent-fg:#fff;--hb-soft:var(--soft);--hb-warn-bg:var(--warn-bg);--hb-warn-fg:var(--warn-fg);--hb-danger:var(--danger)}\n\
.hb a{color:var(--green);text-decoration:none}\n\
.hb a:hover{color:var(--green-dark)}\n\
.hb .hdr{margin-bottom:22px}\n\
.hb .titlerow{display:flex;align-items:center;gap:12px;margin-bottom:6px;flex-wrap:wrap}\n\
.hb h1{font-family:var(--font-heading--family),var(--font-body--family),'Montserrat',sans-serif;font-size:28px;font-weight:700;letter-spacing:-.01em;margin:0;color:var(--ink)}\n\
.hb .pro{font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;background:var(--green);color:#fff;padding:4px 9px;border-radius:20px}\n\
.hb .sub{color:var(--muted);font-size:15px;margin:0;max-width:640px}\n\
.hb section{background:#fff;border:1px solid var(--line);border-radius:16px;padding:24px;margin-bottom:18px;box-shadow:0 1px 2px rgba(20,60,40,.04)}\n\
.hb section.grad{background:linear-gradient(180deg,#fff,var(--soft))}\n\
.hb .stephead{display:flex;align-items:center;gap:10px;margin-bottom:16px;flex-wrap:wrap}\n\
.hb .stepnum{width:26px;height:26px;border-radius:50%;background:var(--green-tint);color:var(--green-dark);font-size:13px;font-weight:800;display:flex;align-items:center;justify-content:center;flex:0 0 auto}\n\
.hb .stepnum.filled{background:var(--green);color:#fff}\n\
.hb .steplabel{font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--muted)}\n\
.hb .stepright{margin-left:auto;font-size:12.5px;color:var(--muted)}\n\
.hb .unitpill{margin-left:auto;font-size:12px;color:var(--muted);background:var(--soft);border:1px solid var(--line);padding:4px 10px;border-radius:20px}\n\
.hb h2{font-size:13px;font-weight:700;color:var(--ink);margin:0 0 10px}\n\
.hb label{font-size:12.5px;color:var(--muted);display:block;margin-bottom:6px;font-weight:600}\n\
.hb input,.hb select{font-size:15px;padding:10px 12px;border:1px solid var(--line);border-radius:10px;\
background:#fff;color:var(--ink);width:100%;font-family:inherit;-webkit-appearance:none}\n\
.hb input:focus,.hb select:focus{outline:none;border-color:var(--green);box-shadow:0 0 0 3px var(--green-tint)}\n\
.hb input[type=checkbox]{-webkit-appearance:auto;appearance:auto;accent-color:var(--green);width:18px;height:18px;min-width:18px;padding:0;border:0;border-radius:0;box-shadow:none;cursor:pointer}\n\
.hb input::-webkit-outer-spin-button,.hb input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}\n\
.hb .row{display:flex;gap:16px;flex-wrap:wrap;align-items:flex-end}\n\
.hb .row>div{flex:1;min-width:130px}\n\
.hb .grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:10px}\n\
.hb .el label{margin-bottom:3px;font-size:12px}\n\
.hb .el input{text-align:right;padding:8px 10px;border-radius:9px}\n\
.hb .el.macro label{color:var(--ink);font-weight:700}\n\
.hb .el.micro label{color:var(--muted);font-weight:500}\n\
.hb .el.micro input{color:var(--muted)}\n\
.hb .subhead{font-size:12px;font-weight:700;color:var(--ink);margin:0 0 8px}\n\
.hb .subhead.micro{color:var(--muted)}\n\
.hb button{font-family:inherit;font-size:14px;font-weight:600;height:40px;padding:0 18px;border-radius:10px;border:1px solid var(--line);\
background:#fff;color:var(--ink);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;line-height:1}\n\
.hb button.primary{background:var(--green);color:#fff;border-color:var(--green);font-weight:700}\n\
.hb button.ghost{background:#fff}\n\
.hb button:active{transform:translateY(1px)}\n\
.hb .btns{display:flex;gap:10px;flex-wrap:wrap}\n\
.hb .pills{display:flex;gap:8px;flex-wrap:wrap}\n\
.hb .pill{font-size:12px;padding:6px 12px;border:1px solid var(--line);border-radius:20px;cursor:pointer;background:var(--soft);color:var(--muted)}\n\
.hb .pill.on{background:var(--green);color:#fff;border-color:var(--green);font-weight:600}\n\
.hb .coverage{background:var(--soft);border:1px solid var(--line);border-radius:12px;padding:14px 16px;margin:0 0 16px}\n\
.hb .covhead{font-size:12.5px;font-weight:700;color:var(--muted);margin-bottom:9px}\n\
.hb .covchips{display:flex;flex-wrap:wrap;gap:7px}\n\
.hb .chip{font-size:12px;padding:5px 11px;border-radius:20px;border:1px dashed var(--line);\
background:#fff;color:var(--muted);white-space:nowrap}\n\
.hb .chip.ok{background:var(--green);color:#fff;border:1px solid var(--green);font-weight:600}\n\
.hb .covmiss{font-size:12px;color:var(--muted);margin-top:9px}\n\
.hb .suggestnotice{display:none;background:var(--warn-bg);color:var(--warn-fg);border-radius:10px;padding:11px 14px;font-size:13px;margin-bottom:12px}\n\
.hb .suggestnotice.show{display:block}\n\
.hb .search{margin-bottom:12px}\n\
.hb .saltlist{max-height:280px;overflow:auto;border:1px solid var(--line);border-radius:12px}\n\
.hb .saltlist::-webkit-scrollbar{width:10px}\n\
.hb .saltlist::-webkit-scrollbar-thumb{background:#d5e0d8;border-radius:8px;border:3px solid #fff}\n\
.hb .saltrow{display:flex;align-items:center;gap:10px;padding:9px 13px;border-bottom:1px solid var(--line);font-size:14px;background:#fff}\n\
.hb .saltrow:last-child{border-bottom:0}\n\
.hb .saltrow.sel{background:var(--green-tint)}\n\
.hb .saltrow.sel .nm{font-weight:600}\n\
.hb .saltrow input[type=checkbox]{width:18px;height:18px;flex:0 0 auto}\n\
.hb .saltrow .nm{flex:1;min-width:0;overflow-wrap:anywhere}\n\
.hb .saltrow .fm{color:var(--muted);font-size:12px;margin-left:8px}\n\
.hb .saltrow .fx{width:74px;flex:0 0 auto;padding:6px 8px}\n\
.hb .stocklink{font-size:12px;font-weight:700;color:var(--green);white-space:nowrap;flex:0 0 auto}\n\
.hb .metrics{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:20px}\n\
.hb .metric{flex:1;min-width:130px;background:#fff;border:1px solid var(--line);border-radius:12px;padding:14px 16px}\n\
.hb .metric .v{font-size:26px;font-weight:800;letter-spacing:-.02em}\n\
.hb .metric .k{font-size:12px;color:var(--muted);margin-top:2px}\n\
.hb .tbl{border:1px solid var(--line);border-radius:12px;overflow-x:auto;background:#fff;margin-bottom:18px}\n\
.hb table{width:100%;border-collapse:collapse;font-size:14px}\n\
.hb th{font-size:11px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:var(--muted);background:var(--soft)}\n\
.hb th,.hb td{padding:11px 16px;text-align:right;border-bottom:1px solid var(--line)}\n\
.hb tr:last-child td{border-bottom:0}\n\
.hb th:first-child,.hb td:first-child{text-align:left}\n\
.hb td.amt{color:var(--green-dark);font-weight:800;font-size:16px;letter-spacing:-.01em;white-space:nowrap}\n\
.hb td.grouprow{background:var(--soft);font-size:11px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--muted);padding:7px 16px;text-align:left}\n\
.hb .rname{font-size:14.5px;font-weight:600}\n\
.hb .buylink{display:inline-block;font-size:12px;font-weight:700;color:var(--green);margin-top:2px}\n\
.hb td.offcell{font-weight:600;color:var(--muted)}\n\
.hb td.offcell.bad{color:var(--danger)}\n\
.hb .warn{background:var(--warn-bg);color:var(--warn-fg);border-radius:10px;padding:11px 14px;font-size:13px;margin-bottom:12px}\n\
.hb .infonote{background:var(--green-tint);color:var(--green-dark);border-radius:10px;padding:11px 14px;font-size:13px;margin-bottom:12px}\n\
.hb details{border-top:1px solid var(--line);margin-top:14px;padding-top:14px}\n\
.hb summary{cursor:pointer;font-size:13px;color:var(--muted);font-weight:600}\n\
.hb .off{opacity:.45}\n\
.hb .hint{font-size:12px;color:var(--muted);margin-top:8px}\n\
.hb .ratiolive{font-size:12px;color:var(--muted);margin:14px 0 2px;line-height:1.6}\n\
.hb .strengthrow{display:flex;gap:12px;flex-wrap:wrap;align-items:flex-end;margin-top:10px}\n\
.hb .strengthrow>div{flex:1;min-width:130px}\n\
.hb .strengthval{font-size:20px;font-weight:800;padding:5px 0;color:var(--ink)}\n\
.hb .foot{font-size:11.5px;color:var(--muted);text-align:center;margin-top:20px}\n\
.hb .whybox{background:var(--soft);border:1px solid var(--line);border-radius:12px;padding:14px 16px;margin-top:14px}\n\
.hb .whybox .whyhead{font-size:12.5px;font-weight:700;color:var(--muted);margin-bottom:8px}\n\
.hb .whybox ul{margin:0;padding-left:18px;font-size:13px;line-height:1.55}\n\
.hb .whybox li{margin-bottom:6px}\n\
.hb .whybox li:last-child{margin-bottom:0}\n\
.hb .whybox .whyhint{font-size:12px;color:var(--muted);margin-top:9px}\n\
.hb details.advcustom{background:#fff;border:1px solid var(--line);border-radius:16px;padding:2px 24px;margin:0 0 18px;box-shadow:0 1px 2px rgba(20,60,40,.04)}\n\
.hb details.advcustom>summary{padding:16px 0;font-size:14px;font-weight:700;color:var(--muted)}\n\
.hb details.advcustom section{border:0;box-shadow:none;border-radius:0;padding:20px 0 24px;margin-bottom:0;border-top:1px solid var(--line)}\n\
.hb .quickhint{font-size:12.5px;color:var(--muted);margin-top:12px}\n\
.hb .crops{display:grid;grid-template-columns:repeat(auto-fill,minmax(72px,1fr));gap:8px}\n\
.hb .cropbtn{border:1px solid var(--line);border-radius:10px;padding:9px 4px;text-align:center;cursor:pointer;background:#fff;transition:.12s}\n\
.hb .cropbtn:hover{border-color:var(--green)}\n\
.hb .cropbtn.on{background:var(--green-tint);border-color:var(--green)}\n\
.hb .cropbtn .ic{font-size:18px;line-height:1}\n\
.hb .cropbtn .nm{font-size:11.5px;font-weight:600;margin-top:4px}\n\
.hb .cropbtn.on .nm{color:var(--green-dark)}\n\
.hb .reciperef{font-size:12.5px;color:var(--muted);margin-top:12px}\n\
.hb .reciperef b{color:var(--ink);font-weight:600}\n\
.hb .orbar{display:flex;align-items:center;gap:14px;margin:20px 0 14px}\n\
.hb .orbar .ln{flex:1;height:1px;background:var(--line)}\n\
.hb .orbar .t{font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--muted)}\n\
.hb .estnote{font-size:12px;color:var(--warn-fg);background:var(--warn-bg);border-radius:8px;padding:8px 11px;margin-top:10px}\n\
.hb .prefs{display:grid;grid-template-columns:repeat(auto-fit,minmax(190px,1fr));gap:9px;margin-top:6px}\n\
.hb .prefopt{border:1px solid var(--line);border-radius:11px;padding:11px 12px;cursor:pointer;background:#fff;display:flex;gap:9px;align-items:flex-start;transition:.12s;position:relative}\n\
.hb .prefopt:hover{border-color:var(--green)}\n\
.hb .prefopt.on{background:var(--green-tint);border-color:var(--green)}\n\
.hb .prefopt.feat{border-width:2px;border-color:var(--green)}\n\
.hb .prefbadge{position:absolute;top:-9px;left:11px;background:var(--green);color:#fff;font-size:9.5px;font-weight:800;letter-spacing:.04em;padding:2px 7px;border-radius:20px}\n\
.hb .prefbox{width:17px;height:17px;border-radius:5px;border:1.5px solid #b7c3b1;flex:0 0 auto;margin-top:1px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:11px;font-weight:800}\n\
.hb .prefopt.on .prefbox{background:var(--green);border-color:var(--green)}\n\
.hb .prefnm{display:block;font-size:13px;font-weight:600;line-height:1.2}\n\
.hb .prefds{display:block;font-size:11px;color:var(--muted);margin-top:2px;line-height:1.3}\n\
.hb .tanks{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:4px}\n\
.hb .tank{border:1px solid var(--line);border-radius:12px;overflow:hidden;background:#fff}\n\
.hb .tank .tk-h{padding:12px 16px;background:var(--soft);border-bottom:1px solid var(--line);display:flex;align-items:center;gap:10px}\n\
.hb .tank .tk-badge{width:24px;height:24px;border-radius:6px;background:var(--green);color:#fff;font-weight:800;font-size:13px;display:flex;align-items:center;justify-content:center;flex:0 0 auto}\n\
.hb .tank .tk-t{font-size:13px;font-weight:700}\n\
.hb .tank .tk-s{font-size:11.5px;color:var(--muted)}\n\
.hb .tank .prod{display:flex;align-items:center;gap:12px;padding:11px 16px;border-bottom:1px solid var(--line)}\n\
.hb .tank .prod:last-of-type{border-bottom:0}\n\
.hb .tank .prod .pi{flex:1;min-width:0}\n\
.hb .tank .prod .pn{font-size:14px;font-weight:600}\n\
.hb .tank .prod .pg{font-size:11.5px;color:var(--muted)}\n\
.hb .tank .prod .buy2{font-size:11.5px;font-weight:700;color:var(--green)}\n\
.hb .tank .prod .amt2{font-weight:800;color:var(--green-dark);font-size:15px;white-space:nowrap}\n\
.hb .tank .tk-total{padding:10px 16px;font-size:12.5px;font-weight:700;color:var(--muted);background:var(--soft);display:flex;justify-content:space-between}\n\
@media (max-width:560px){.hb .tanks{grid-template-columns:1fr}}\n\
.hb section.grad>*{transition:opacity .15s}\n\
.hb.hb-loading section.grad>*:not(.calcspin):not(.stephead){opacity:.45;pointer-events:none}\n\
.hb .calcspin{display:none;align-items:center;gap:10px;font-size:13.5px;font-weight:700;color:var(--green-dark);margin:0 0 14px}\n\
.hb.hb-loading .calcspin{display:flex}\n\
.hb .calcspin .spin{width:16px;height:16px;border:2.5px solid var(--green-tint);border-top-color:var(--green);border-radius:50%;animation:hbspin .7s linear infinite;flex:0 0 auto}\n\
@keyframes hbspin{to{transform:rotate(360deg)}}\n\
.hb .infobtn{width:22px;height:22px;border-radius:50%;border:1px solid var(--line);background:#fff;color:var(--muted);font-size:12px;font-weight:700;cursor:pointer;padding:0;line-height:1;flex:0 0 auto;font-family:Georgia,serif;font-style:italic}\n\
.hb .infobtn:hover{border-color:var(--green);color:var(--green)}\n\
.hb .assume{max-height:65vh;overflow:auto;font-size:13px;line-height:1.6;color:var(--ink)}\n\
.hb .assume h3{font-size:12px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--muted);margin:14px 0 6px}\n\
.hb .assume h3:first-child{margin-top:0}\n\
.hb .assume ul{margin:0;padding-left:18px}\n\
.hb .assume li{margin-bottom:5px}\n\
.hb .hb-toast{position:fixed;left:50%;bottom:22px;transform:translateX(-50%) translateY(8px);\
background:var(--ink);color:#fff;padding:11px 20px;border-radius:26px;font-size:14px;font-weight:600;\
box-shadow:0 8px 28px rgba(0,0,0,.28);z-index:2147483647;opacity:0;pointer-events:none;transition:opacity .18s,transform .18s;max-width:90vw;text-align:center}\n\
.hb .hb-toast.show{opacity:1;transform:translateX(-50%) translateY(0)}\n\
.hb .hb-copybox{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:16px}\n\
.hb .hb-copycard{background:#fff;border-radius:16px;padding:20px;max-width:520px;width:100%;box-shadow:0 12px 40px rgba(0,0,0,.4)}\n\
.hb .hb-copyhd{font-size:13px;font-weight:700;margin-bottom:8px;color:var(--ink)}\n\
.hb .hb-copyarea{width:100%;height:200px;font:12px/1.4 monospace;padding:10px;border:1px solid var(--line);border-radius:10px;background:var(--soft);color:var(--ink);resize:vertical;margin-bottom:10px}\n\
.hb .chathint{font-size:12px;color:var(--muted);margin-bottom:8px}\n\
.hb .chatlog{display:flex;flex-direction:column;gap:8px;max-height:300px;overflow:auto;margin-bottom:10px;padding:2px}\n\
.hb .bubble{padding:9px 12px;border-radius:13px;font-size:14px;line-height:1.5;white-space:pre-wrap;max-width:92%}\n\
.hb .bubble.user{align-self:flex-end;background:var(--green);color:#fff;border-bottom-right-radius:3px}\n\
.hb .bubble.assistant{align-self:flex-start;background:var(--soft);color:var(--ink);border-bottom-left-radius:3px}\n\
.hb .chatinput{width:100%;resize:vertical;font-size:15px;padding:10px 12px;border:1px solid var(--line);border-radius:10px;background:#fff;color:var(--ink);font-family:inherit}\n\
/* ---- mobile: kept LAST so these overrides win at equal specificity ---- */\n\
@media (max-width:480px){\
.hb section{padding:16px}\
.hb details.advcustom{padding:2px 16px}\
.hb .tbl table{font-size:13px}\
.hb th,.hb td{padding:8px 7px}\
.hb th{white-space:nowrap}\
.hb td.amt{font-size:15px}\
.hb .metric{padding:12px 14px;min-width:104px}\
.hb .coverage{padding:12px 14px}\
.hb .stephead{gap:8px}\
}\n";

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "class") n.className = attrs[k];
      else if (k === "html") n.innerHTML = attrs[k];
      else if (k === "text") n.textContent = attrs[k];
      else if (k.slice(0, 2) === "on") n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c != null) n.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return n;
  }
  function fmt(n, p) { if (!isFinite(n)) return "0"; var m = Math.pow(10, p == null ? 2 : p); return String(Math.round(n * m) / m); }
  // Human-friendly dose: mL for liquids, g normally, mg when sub-0.1 g (micros in small batches).
  function amountStr(row) {
    if (row.mL != null) return fmt(row.mL, 3) + " mL";
    var g = row.grams;
    if (g > 0 && g < 0.1) return fmt(g * 1000, g < 0.001 ? 3 : 2) + " mg";
    return fmt(g, 3) + " g";
  }
  // Colour category for a % deviation: on target / within the element's agronomic
  // band (bandFor) / genuinely out of range. Keyed per element — S at −25% is fine,
  // P at −25% is not.
  function statusClass(off, key) {
    if (Math.abs(off) <= 5) return "on";
    var b = bandFor(key || "");
    if (off >= b[0] && off <= b[1]) return "tol";
    return off > 0 ? "over" : "low";
  }

  // Numbered step header: green-tint chip (filled green for the final step) +
  // uppercase label, with an optional right-aligned node (unit pill / per-batch note).
  function stepHeader(num, label, opts) {
    opts = opts || {};
    var kids = [
      el("span", { class: "stepnum" + (opts.filled ? " filled" : ""), text: String(num) }),
      el("span", { class: "steplabel", text: label })
    ];
    if (opts.right) kids.push(opts.right);
    return el("div", { class: "stephead" }, kids);
  }

  function mount(host) {
    // Font: the widget inherits the host theme's typography via the CSS custom
    // properties --font-body--family / --font-heading--family (custom properties
    // pierce the shadow boundary; `all:initial` does not reset them), so it
    // matches whatever the Dwell theme sets — Montserrat is only a fallback.
    var root = host.attachShadow ? host.attachShadow({ mode: "open" }) : host;
    root.appendChild(el("style", { text: STYLE }));

    // ---- state ----
    var state = {
      unit: "mmol",
      siAsSiO2: false,
      volume: 1000, volumeUnit: "L",
      targets: {},           // key -> display value string
      water: {},             // key -> ppm value string
      selected: {},          // salt name -> {salt, fixed}
      abMode: false, concFactor: 100,
      dof: "",
      ecModel: "theo",
      prefs: {},             // optimizer trade-off preferences (tickboxes)
      salts: HB_DATA.salts.slice(),
      // No API call happens until the visitor explicitly starts (crop tap,
      // recipe pick, or the "Calculate recipe" button) — most page views are
      // for the simple calculator above and must not invoke the backend.
      armed: false
    };

    var wrap = el("div", { class: "hb" });
    root.appendChild(wrap);

    // ---- calculation API client ----
    // All chemistry happens server-side. Same-origin via the App Proxy by
    // default; overridable for local dev.
    var endpoint = host.getAttribute("data-calc-endpoint") ||
      (window.HABITAT_CALC && window.HABITAT_CALC.endpoint) || "/apps/calc";
    var inflight = null;          // AbortController of the request in flight
    var lastTargetsEC = null;     // EC of the current targets, from the last response
    var lastResult = null;

    function saltSupplies(s, key) {
      return s.supplies ? s.supplies.indexOf(key) >= 0 : !!(s.comp && (s.comp[key] || 0) > 0);
    }
    function buildBody(extra) {
      var targetsPpm = targetsPpmMap();
      var waterPpm = {};
      ELEMENTS.forEach(function (e) { var w = parseFloat(state.water[e.key]); waterPpm[e.key] = isFinite(w) ? w : 0; });
      var saltNames = Object.keys(state.selected);
      var fixedGrams = {};
      saltNames.forEach(function (n) { var f = state.selected[n].fixed; if (f > 0) fixedGrams[n] = f; });
      var customSalts = saltNames
        .map(function (n) { return state.selected[n].salt; })
        .filter(function (s) { return s.custom; })
        .map(function (s) { return { name: s.name, formula: s.formula, purity: s.purity, comp: s.comp, isLiquid: s.isLiquid, density: s.density }; });
      var body = {
        targetsPpm: targetsPpm, waterPpm: waterPpm, volumeL: volumeLiters() || 1000,
        saltNames: saltNames, fixedGrams: fixedGrams, customSalts: customSalts,
        dof: state.dof || null, abMode: state.abMode, concFactor: state.concFactor,
        ecModel: state.ecModel, preferences: state.prefs, optimize: false
      };
      extra = extra || {};
      for (var k in extra) {
        if (extra[k] === null && k === "saltNames") delete body.saltNames; // server picks the set
        else body[k] = extra[k];
      }
      return body;
    }
    // POST to the calc API. Resolves with the response JSON, or null when the
    // request was superseded (aborted) or failed (an error banner is shown).
    function apiCalc(extra) {
      clearTimeout(timer); // an explicit call supersedes any pending debounced calc()
      if (inflight) inflight.abort();
      var ctrl = (typeof AbortController !== "undefined") ? new AbortController() : null;
      inflight = ctrl;
      wrap.classList.add("hb-loading");
      return fetch(endpoint, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(buildBody(extra)),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error((j && j.message) || ("calculation service error (HTTP " + r.status + ")"));
          return j;
        });
      }).then(function (json) {
        if (inflight === ctrl) { inflight = null; wrap.classList.remove("hb-loading"); }
        if (json && json.targetsEC != null) lastTargetsEC = json.targetsEC;
        return json;
      }).catch(function (err) {
        if (err && err.name === "AbortError") return null; // superseded by a newer request
        if (inflight === ctrl) { inflight = null; wrap.classList.remove("hb-loading"); }
        warnBox.innerHTML = "";
        warnBox.appendChild(el("div", { class: "warn",
          text: "⚠ Couldn't reach the calculation service (" + (err && err.message ? err.message : "network error") + "). Check your connection and try again." }));
        return null;
      });
    }
    function applyResponse(r) {
      if (!r) return;
      lastResult = r;
      renderResults(r);
      updateTargetInfo();
    }
    wrap.appendChild(el("div", { class: "hdr" }, [
      el("div", { class: "titlerow" }, [
        el("h1", { text: "Advanced Nutrient Calculator" }),
        el("span", { class: "pro", text: "PRO" })
      ]),
      el("p", { class: "sub", text: "Build a recipe from scratch: set your target concentrations per element, choose the salts you have, and get exact weights and estimated EC — solved by Habitat's lab-grade recipe engine." })
    ]));

    // ================= QUICK RECIPE (wizard) =================
    // The zero-puzzle path: crop + tank size -> preset targets -> auto-picked,
    // auto-optimized salt set -> recipe. Steps 1-3 below stay available for
    // fine-tuning inside the "advanced" fold.
    var secStart = el("section");
    secStart.appendChild(stepHeader(1, "Start recipe"));

    // The exact-recipe dropdown ("the list"). Also synced when a crop is picked.
    var presetSel = el("select");
    presetSel.appendChild(el("option", { value: "", text: "— choose a specific recipe —" }));
    HB_DATA.formulations.forEach(function (f, i) { presetSel.appendChild(el("option", { value: String(i), text: f.name })); });
    presetSel.addEventListener("change", function () {
      if (presetSel.value === "") return;
      loadRecipe(+presetSel.value, null);
    });

    var recipeRef = el("div", { class: "reciperef" });

    // Crop quick-picks — each is a one-click shortcut to an existing recipe.
    var cropGrid = el("div", { class: "crops" });
    var cropBtns = [];
    CROPS_QUICK.forEach(function (c) {
      var idx = HB_DATA.formulations.findIndex(function (f) { return f.name === c.recipe; });
      var btn = el("div", { class: "cropbtn" }, [el("div", { class: "ic", text: c.icon }), el("div", { class: "nm", text: c.name })]);
      btn.__idx = idx;
      btn.addEventListener("click", function () {
        cropBtns.forEach(function (b) { b.classList.remove("on"); });
        btn.classList.add("on");
        loadRecipe(idx, c.name);
      });
      cropBtns.push(btn); cropGrid.appendChild(btn);
    });
    secStart.appendChild(cropGrid);
    secStart.appendChild(recipeRef);
    secStart.appendChild(el("div", { class: "orbar" }, [el("span", { class: "ln" }), el("span", { class: "t", text: "or pick an exact recipe" }), el("span", { class: "ln" })]));
    secStart.appendChild(el("div", { class: "row" }, [el("div", {}, [el("label", { text: "Published recipe" }), presetSel])]));
    secStart.appendChild(el("div", { class: "quickhint", text: "Tap a crop to load a proven recipe — it stays editable under Customize targets. We pick the salts and solve the weights for you." }));
    wrap.appendChild(secStart);

    // Load a formulation's targets, then let the server pick + optimise the
    // salts and solve — one round-trip, selection synced from the response.
    function loadRecipe(i, cropName) {
      state.armed = true;
      applyPreset(i);
      var f = HB_DATA.formulations[i];
      recipeRef.innerHTML = "";
      recipeRef.appendChild(document.createTextNode(cropName ? cropName + " → " : "Recipe: "));
      recipeRef.appendChild(el("b", { text: f ? f.name : "" }));
      if (!cropName) cropBtns.forEach(function (b) { b.classList.toggle("on", b.__idx === i); });
      state.selected = {};
      runOptimize(true).then(function (r) {
        if (r) toast("✓ Recipe loaded — weights & products below");
      });
    }

    // ================= TARGETS =================
    var secT = el("section");
    // (updated by convertUnit; kept for the units row below)
    var unitPillEl = el("span", { class: "unitpill", text: UNITS[state.unit].label });

    // applyPreset is shared by the Start-recipe crop buttons + the recipe dropdown
    // (presetSel itself lives in the Start section above).
    function applyPreset(i) {
      var f = HB_DATA.formulations[i];
      if (!f) return;
      // Presets are stored in ppm — convert into whatever unit is currently selected.
      ELEMENTS.forEach(function (e) {
        var ppm = f.targets[e.key] || 0;
        state.targets[e.key] = ppm ? String(round(ppmToDisplay(e, ppm, state.unit, state.siAsSiO2), 4)) : "";
      });
      presetSel.value = String(i);
      renderTargets(); scheduleCalc();
    }

    var unitWrap = el("div", { class: "pills" });
    function unitPills() {
      unitWrap.innerHTML = "";
      Object.keys(UNITS).forEach(function (u) {
        unitWrap.appendChild(el("span", {
          class: "pill" + (state.unit === u ? " on" : ""), text: UNITS[u].label,
          onclick: function () { convertUnit(u); }
        }));
      });
    }
    function convertUnit(u) {
      // convert current entered target values from old unit to new unit
      ELEMENTS.forEach(function (e) {
        var raw = parseFloat(state.targets[e.key]);
        if (isFinite(raw)) {
          var ppm = targetToPpm(e, raw, state.unit, state.siAsSiO2);
          state.targets[e.key] = String(round(ppmToDisplay(e, ppm, u, state.siAsSiO2), 4));
        }
      });
      state.unit = u; unitPillEl.textContent = UNITS[u].label; unitPills(); renderTargets(); scheduleCalc();
    }

    var macroGrid = el("div", { class: "grid" });
    var microGrid = el("div", { class: "grid" });
    function renderTargets() {
      macroGrid.innerHTML = ""; microGrid.innerHTML = "";
      ELEMENTS.forEach(function (e) {
        var lbl = (e.key === "Si" && state.siAsSiO2) ? "Si (as SiO₂)" : e.label;
        var input = el("input", {
          type: "number", inputmode: "decimal", min: "0", step: "any",
          value: state.targets[e.key] || "",
          placeholder: "0",
          oninput: function () { state.targets[e.key] = input.value; scheduleCalc(); }
        });
        var cell = el("div", { class: "el " + e.group }, [el("label", { text: lbl }), input]);
        (e.group === "macro" ? macroGrid : microGrid).appendChild(cell);
      });
    }

    var siToggle = el("label", { class: "pill" + (state.siAsSiO2 ? " on" : ""), text: "Si as SiO₂" });
    siToggle.style.cursor = "pointer";
    siToggle.addEventListener("click", function () {
      state.siAsSiO2 = !state.siAsSiO2;
      siToggle.className = "pill" + (state.siAsSiO2 ? " on" : "");
      renderTargets(); scheduleCalc();
    });

    secT.appendChild(el("div", { class: "row" }, [
      el("div", {}, [el("label", { text: "Units" }), unitWrap]),
      el("div", { style: "flex:0 0 auto" }, [el("label", { text: " " }), siToggle])
    ]));
    secT.appendChild(el("div", { class: "subhead", text: "Macronutrients", style: "margin-top:20px" }));
    secT.appendChild(macroGrid);
    secT.appendChild(el("div", { class: "subhead micro", text: "Micronutrients", style: "margin-top:18px" }));
    secT.appendChild(microGrid);

    // live target ratios (updates as you type)
    var ratioLive = el("div", { class: "ratiolive" });
    secT.appendChild(ratioLive);

    // strength / target-EC control — scales the whole recipe to a target EC, ratios preserved
    var strengthVal = el("strong", { class: "strengthval", text: "—" });
    var ecTargetInput = el("input", { type: "number", min: "0", step: "0.1", value: "2.0" });
    var scaleBtn = el("button", { class: "primary", type: "button", text: "Scale to EC",
      onclick: function () { var t = parseFloat(ecTargetInput.value); if (t > 0) scaleToEC(t); else toast("Enter a target EC above 0."); } });
    secT.appendChild(el("div", { class: "strengthrow" }, [
      el("div", {}, [el("label", { text: "Current strength (of targets)" }), strengthVal]),
      el("div", {}, [el("label", { text: "Target EC (mS/cm)" }), ecTargetInput]),
      el("div", { style: "flex:0 0 auto" }, [el("label", { text: " " }), scaleBtn])
    ]));
    secT.appendChild(el("div", { class: "hint", text: "“Scale to EC” multiplies every target so the solution reaches your EC — all nutrient ratios stay exactly the same, only the overall strength changes." }));
    // Customize targets — collapsed by default; the chosen recipe already set them,
    // this is for growers who want to fine-tune the per-element ppm.
    var targetsDet = el("details", { class: "advcustom" });
    targetsDet.appendChild(el("summary", { text: "Customize targets" }));
    targetsDet.appendChild(secT);
    wrap.appendChild(targetsDet);

    // --- target EC + ratio helpers ---
    function targetsPpmMap() {
      var m = {};
      ELEMENTS.forEach(function (e) {
        var v = parseFloat(state.targets[e.key]);
        m[e.key] = isFinite(v) ? targetToPpm(e, v, state.unit, state.siAsSiO2) : 0;
      });
      return m;
    }
    // The EC of the current targets comes back with every API response
    // (targetsEC) — shown in the strength readout below.
    function scaleToEC(target) {
      var ppm = targetsPpmMap();
      var sum = 0; ELEMENTS.forEach(function (e) { sum += ppm[e.key]; });
      if (sum <= 0) { toast("Enter your nutrient targets first, then scale to EC."); return; }
      state.armed = true; // explicit user action
      apiCalc({ scaleToEC: target }).then(function (r) {
        if (!r) return;
        if (r.scaledTargetsPpm) {
          ELEMENTS.forEach(function (e) {
            var v = r.scaledTargetsPpm[e.key];
            if (v > 0) state.targets[e.key] = String(round(ppmToDisplay(e, v, state.unit, state.siAsSiO2), 4));
          });
        }
        renderTargets();
        applyResponse(r);
        toast("✓ Scaled to EC ≈ " + fmt(target, 2) + " mS/cm");
      });
    }
    function updateTargetInfo() {
      strengthVal.textContent = lastTargetsEC != null ? fmt(lastTargetsEC, 2) + " mS/cm" : "—";
      var v = function (k) { var x = parseFloat(state.targets[k]); return isFinite(x) ? x : 0; };
      var N = v("nNO3") + v("nNH4");
      var r = function (a, b) { return b > 0 ? round(a / b, 2) : 0; };
      var npk = N > 0 ? ("1 : " + r(v("P"), N) + " : " + r(v("K"), N)) : "—";
      var kcamg = v("K") > 0 ? ("1 : " + r(v("Ca"), v("K")) + " : " + r(v("Mg"), v("K"))) : "—";
      var nh4 = N > 0 ? round(v("nNH4") / N * 100, 0) : 0;
      ratioLive.textContent = "Target ratios (" + (state.unit === "mmol" ? "molar" : "mass") + ") — N:P:K " + npk +
        "   ·   K:Ca:Mg " + kcamg + "   ·   NH₄ = " + nh4 + "% of N";
    }

    // ================= SOLUTION SETUP =================
    var secV = el("section");
    secV.appendChild(stepHeader(2, "Source water & batch"));
    var volInput = el("input", { type: "number", min: "0", step: "any", value: String(state.volume),
      oninput: function () { state.volume = parseFloat(volInput.value) || 0; scheduleCalc(); } });

    // Named source-water presets (Rain/RO default). Estimates are flagged.
    var waterEst = el("div", { class: "estnote" }); waterEst.style.display = "none";
    var waterPreset = el("select");
    WATER_SOURCES.forEach(function (w, i) { waterPreset.appendChild(el("option", { value: String(i), text: w.name })); });
    waterPreset.appendChild(el("option", { value: "custom", text: "Custom — enter my own" }));
    function applyWaterSource(sel) {
      if (sel === "custom") { waterEst.style.display = "none"; return; } // keep values; user edits below
      var w = WATER_SOURCES[+sel];
      ELEMENTS.forEach(function (e) { var v = w.comp[e.key]; state.water[e.key] = v ? String(v) : ""; });
      waterEst.textContent = w.est ? "⚠ Estimated composition — replace with your real water-report figures under “Customize composition”." : "";
      waterEst.style.display = w.est ? "block" : "none";
      renderWater(); scheduleCalc();
    }
    waterPreset.addEventListener("change", function () { applyWaterSource(waterPreset.value); });

    secV.appendChild(el("div", { class: "row" }, [
      el("div", {}, [el("label", { text: "Reservoir volume (litres)" }), volInput]),
      el("div", {}, [el("label", { text: "Source water" }), waterPreset])
    ]));
    secV.appendChild(waterEst);

    var waterDet = el("details");
    waterDet.appendChild(el("summary", { text: "Customize composition (ppm)" }));
    var waterGrid = el("div", { class: "grid" });
    function renderWater() {
      waterGrid.innerHTML = "";
      ELEMENTS.forEach(function (e) {
        var input = el("input", { type: "number", min: "0", step: "any", value: state.water[e.key] || "", placeholder: "0",
          oninput: function () { state.water[e.key] = input.value; scheduleCalc(); } });
        waterGrid.appendChild(el("div", { class: "el" }, [el("label", { text: e.label }), input]));
      });
    }
    waterDet.appendChild(waterGrid);
    secV.appendChild(waterDet);
    wrap.appendChild(secV);   // own visible section (not folded)

    // ================= TRADE-OFF PREFERENCES =================
    // Soft optimizer hints. Each re-weights the salt-set search (server-side);
    // toggling one re-optimizes. "Prefer available" leans on Habitat-stocked
    // salts (those with a product link). All optional; default none.
    var PREF_OPTS = [
      { id: "stocked", feat: true, badge: "Habitat", nm: "Prefer available fertilisers", ds: "Favour salts Habitat stocks — buy in one place" },
      { id: "sulfateLow", nm: "Keep sulphate low", ds: "Draw potassium from nitrate, not sulfate" },
      { id: "avoidChloride", nm: "Avoid chloride", ds: "Skip KCl / NH₄Cl ballast sources" },
      { id: "minAmmonium", nm: "Minimise ammonium", ds: "Only what calcium nitrate forces" },
      { id: "fewestSalts", nm: "Fewest salts", ds: "Simplest mix to weigh out" },
      { id: "lowestCost", nm: "Lowest cost", ds: "Cheapest salts that still fit" }
    ];
    var secP = el("section");
    secP.appendChild(stepHeader("⚖", "Trade-off preferences", { right:
      el("span", { class: "stepright", text: "optional" }) }));
    secP.appendChild(el("div", { class: "hint", style: "margin:-4px 0 4px",
      text: "No perfect recipe exists — salts are coupled. Tick what to protect and we solve around it." }));
    var prefGrid = el("div", { class: "prefs" });
    PREF_OPTS.forEach(function (o) {
      var card = el("div", { class: "prefopt" + (o.feat ? " feat" : ""), role: "checkbox", "aria-checked": "false", tabindex: "0" });
      var check = el("span", { class: "prefbox", text: "" });
      if (o.badge) card.appendChild(el("span", { class: "prefbadge", text: o.badge }));
      card.appendChild(check);
      card.appendChild(el("span", {}, [el("span", { class: "prefnm", text: o.nm }), el("span", { class: "prefds", text: o.ds })]));
      function toggle() {
        var on = !state.prefs[o.id];
        if (on) state.prefs[o.id] = true; else delete state.prefs[o.id];
        card.classList.toggle("on", on);
        card.setAttribute("aria-checked", on ? "true" : "false");
        check.textContent = on ? "✓" : "";
        // Preferences steer the optimizer. Re-seed from the standard toolbox
        // (clear the current pick) so the hill-climb starts fresh — otherwise it
        // optimizes from the previous recipe and lands in a worse local optimum.
        state.armed = true;
        state.selected = {};
        runOptimize(true);
      }
      card.addEventListener("click", toggle);
      card.addEventListener("keydown", function (ev) { if (ev.key === " " || ev.key === "Enter") { ev.preventDefault(); toggle(); } });
      prefGrid.appendChild(card);
    });
    secP.appendChild(prefGrid);
    wrap.appendChild(secP);

    // ================= SALTS =================
    var secS = el("section");

    // coverage strip — shows which targeted nutrients already have a source
    var coverageBox = el("div", { class: "coverage" });
    secS.appendChild(coverageBox);

    var optimizeBtn = el("button", { class: "primary", type: "button", text: "✨ Optimize my salts",
      title: "Search the whole catalogue for the combination that best hits your targets",
      onclick: function () { runOptimize(false); } });
    var suggestBtn = el("button", { type: "button", text: "Suggest salts",
      onclick: function () { suggestSalts(); } });
    var clearBtn = el("button", { class: "ghost", type: "button", text: "Clear selection",
      onclick: function () { state.selected = {}; renderSalts(search.value.toLowerCase()); scheduleCalc(); } });
    secS.appendChild(el("div", { class: "btns", style: "margin-bottom:6px" }, [optimizeBtn, suggestBtn, clearBtn]));

    // Replace the selection with the given salt names (keeps any weight locks
    // for salts that survive the change), then refresh the list + coverage.
    function setSelection(names) {
      var prev = state.selected;
      state.selected = {};
      (names || []).forEach(function (n) {
        var s = (prev[n] && prev[n].salt) || findSaltByName(n);
        if (s) state.selected[n] = { salt: s, fixed: prev[n] ? prev[n].fixed : null };
      });
      renderSalts(search.value.toLowerCase()); renderCoverage();
    }

    // Ask the API to optimize the salt set (server-side hill-climb over the
    // catalogue). quiet=true skips the per-change toast (the crop-load flow
    // shows its own). Returns a promise resolving with the API response.
    function runOptimize(quiet) {
      var targetsPpm = targetsPpmMap();
      var any = false;
      ELEMENTS.forEach(function (e) { if (targetsPpm[e.key] > 0) any = true; });
      if (!any) { showSuggestNotice("Enter your targets in step 1 (or use the Quick recipe above) first."); return Promise.resolve(null); }
      state.armed = true; // explicit user action
      var start = Object.keys(state.selected);
      var extra = { optimize: true };
      if (!start.length) extra.saltNames = null; // let the server seed the toolbox first
      return apiCalc(extra).then(function (r) {
        if (!r) return null;
        var best = r.saltNames || [];
        var added = best.filter(function (n) { return start.indexOf(n) < 0; });
        var removed = start.filter(function (n) { return best.indexOf(n) < 0; });
        setSelection(best);
        applyResponse(r);
        if (!quiet) {
          toast(added.length || removed.length
            ? "✓ Optimized — added " + (added.length ? added.length + " (" + added.join(", ") + ")" : "0") + ", removed " + removed.length
            : "✓ Your selection is already the best fit");
        }
        return r;
      });
    }

    // inline notice shown right by the Suggest button (not down in the results)
    var suggestNotice = el("div", { class: "suggestnotice" });
    secS.appendChild(suggestNotice);
    var noticeTimer = null;
    function showSuggestNotice(msg) {
      suggestNotice.textContent = "⚠ " + msg;
      suggestNotice.classList.add("show");
      clearTimeout(noticeTimer);
      noticeTimer = setTimeout(function () { suggestNotice.classList.remove("show"); }, 4000);
    }

    var search = el("input", { class: "search", type: "search", placeholder: "Search salts…",
      oninput: function () { renderSalts(search.value.toLowerCase()); } });
    secS.appendChild(search);
    var saltList = el("div", { class: "saltlist" });
    function renderSalts(filter) {
      saltList.innerHTML = "";
      state.salts.forEach(function (s) {
        if (filter && s.name.toLowerCase().indexOf(filter) < 0 && (s.formula || "").toLowerCase().indexOf(filter) < 0) return;
        var isSel = !!state.selected[s.name];
        var cb = el("input", { type: "checkbox" });
        cb.checked = isSel;
        cb.addEventListener("change", function () {
          if (cb.checked) state.selected[s.name] = { salt: s, fixed: null };
          else delete state.selected[s.name];
          renderSalts(search.value.toLowerCase()); scheduleCalc();
        });
        var fx = el("input", { class: "fx", type: "number", min: "0", step: "any", placeholder: "lock g",
          title: "Optional: lock this salt to a fixed weight (grams)",
          value: (isSel && state.selected[s.name].fixed) ? String(state.selected[s.name].fixed) : "",
          oninput: function () { if (state.selected[s.name]) { state.selected[s.name].fixed = parseFloat(fx.value) || null; scheduleCalc(); } } });
        var url = PRODUCT_LINKS[s.name];
        var stockLink = url ? el("a", { class: "stocklink", href: url, target: "_blank", rel: "noopener",
          text: "In stock ↗", onclick: function (ev) { ev.stopPropagation(); } }) : null;
        var rowEl = el("div", { class: "saltrow" + (isSel ? " sel" : "") }, [
          cb, el("span", { class: "nm" }, [s.name, s.formula ? el("span", { class: "fm", text: s.formula }) : null]),
          stockLink, isSel ? fx : null
        ]);
        saltList.appendChild(rowEl);
      });
    }
    secS.appendChild(saltList);
    secS.appendChild(el("div", { class: "hint", text: "Tip: “lock g” fixes a salt to a set weight; the solver works around it. Leave blank to let the solver choose." }));

    // Which targeted elements are already supplied by a selected salt.
    function coverageState() {
      var targeted = ELEMENTS.filter(function (e) { return parseFloat(state.targets[e.key]) > 0; });
      var sel = Object.keys(state.selected).map(function (k) { return state.selected[k].salt; });
      return targeted.map(function (e) {
        return { el: e, covered: sel.some(function (s) { return saltSupplies(s, e.key); }) };
      });
    }
    function renderCoverage() {
      coverageBox.innerHTML = "";
      var cov = coverageState();
      if (!cov.length) {
        coverageBox.appendChild(el("div", { class: "hint", text: "Enter your target concentrations above, then pick salts here to supply them." }));
        return;
      }
      var done = cov.filter(function (c) { return c.covered; }).length;
      coverageBox.appendChild(el("div", { class: "covhead", text: "Nutrient coverage — " + done + " of " + cov.length + " sourced" }));
      var strip = el("div", { class: "covchips" });
      cov.forEach(function (c) {
        strip.appendChild(el("span", { class: "chip" + (c.covered ? " ok" : ""),
          title: c.covered ? "A selected salt supplies this" : "No selected salt supplies this yet",
          text: (c.covered ? "✓ " : "") + c.el.label }));
      });
      coverageBox.appendChild(strip);
      var miss = cov.filter(function (c) { return !c.covered; });
      if (miss.length) coverageBox.appendChild(el("div", { class: "covmiss",
        text: miss.length + " nutrient" + (miss.length > 1 ? "s" : "") + " still need a source — add a salt below, or tap “Suggest salts”." }));
    }
    function findSaltByName(nm) {
      for (var i = 0; i < state.salts.length; i++) if (state.salts[i].name === nm) return state.salts[i];
      return null;
    }
    // Suggest a standard, solvable salt set — the server applies its curated
    // grower toolbox (one independent salt per targeted element) and returns
    // the picked names. Returns a promise resolving with the API response.
    function suggestSalts() {
      var t = function (k) { return parseFloat(state.targets[k]) > 0; };
      var targeted = ELEMENTS.filter(function (e) { return t(e.key); });
      if (!targeted.length) { showSuggestNotice("Enter your target concentrations in step 1 first, then tap “Suggest salts”."); return Promise.resolve(null); }
      state.armed = true; // explicit user action
      return apiCalc({ saltNames: null, optimize: false }).then(function (r) {
        if (!r) return null;
        setSelection(r.saltNames);
        applyResponse(r);
        return r;
      });
    }

    // --- custom salt (session only) ---
    var custDet = el("details");
    custDet.appendChild(el("summary", { text: "Add a custom salt (this session only)" }));
    var cName = el("input", { type: "text", placeholder: "Name" });
    var cFormula = el("input", { type: "text", placeholder: "Formula (label only)" });
    var cPurity = el("input", { type: "number", value: "100", step: "any", placeholder: "Purity %" });
    var cGrid = el("div", { class: "grid" });
    var cInputs = {};
    ELEMENTS.forEach(function (e) {
      var input = el("input", { type: "number", step: "any", min: "0", placeholder: "0" });
      cInputs[e.key] = input;
      cGrid.appendChild(el("div", { class: "el" }, [el("label", { text: "% " + e.label }), input]));
    });
    var addBtn = el("button", { class: "primary", text: "Add salt", onclick: function () {
      var nm = (cName.value || "").trim(); if (!nm) return;
      var comp = {}; ELEMENTS.forEach(function (e) { comp[e.key] = parseFloat(cInputs[e.key].value) || 0; });
      // custom:true => the full composition is sent along with API requests
      // (catalogue salts are referenced by name only; the server knows them).
      var salt = { name: nm, formula: (cFormula.value || "").trim(), purity: (parseFloat(cPurity.value) || 100) / 100,
        comp: comp, isLiquid: 0, density: 0, custom: true,
        supplies: ELEMENTS.filter(function (e) { return comp[e.key] > 0; }).map(function (e) { return e.key; }) };
      state.salts.unshift(salt); cName.value = cFormula.value = ""; cPurity.value = "100";
      ELEMENTS.forEach(function (e) { cInputs[e.key].value = ""; });
      renderSalts(""); search.value = "";
    } });
    custDet.appendChild(el("div", { class: "row" }, [
      el("div", {}, [el("label", { text: "Name" }), cName]),
      el("div", {}, [el("label", { text: "Formula" }), cFormula]),
      el("div", {}, [el("label", { text: "Purity %" }), cPurity])
    ]));
    custDet.appendChild(el("label", { text: "Element content (% w/w)" }));
    custDet.appendChild(cGrid);
    custDet.appendChild(el("div", { class: "btns" }, [addBtn]));
    secS.appendChild(custDet);

    // --- advanced options ---
    var advDet = el("details");
    advDet.appendChild(el("summary", { text: "Advanced options" }));
    var abToggle = el("input", { type: "checkbox" });
    abToggle.addEventListener("change", function () { state.abMode = abToggle.checked; cfInput.parentNode.classList.toggle("off", !state.abMode); scheduleCalc(); });
    var cfInput = el("input", { type: "number", value: "100", min: "1", step: "any",
      oninput: function () { state.concFactor = parseFloat(cfInput.value) || 1; scheduleCalc(); } });
    var dofSel = el("select");
    dofSel.appendChild(el("option", { value: "", text: "None" }));
    ELEMENTS.forEach(function (e) { dofSel.appendChild(el("option", { value: e.key, text: e.label })); });
    dofSel.addEventListener("change", function () { state.dof = dofSel.value; scheduleCalc(); });
    var ecSel = el("select");
    [["theo", "Theoretical / ionic (recommended)"], ["emp", "Empirical (A+B mixes only)"]].forEach(function (o) { ecSel.appendChild(el("option", { value: o[0], text: o[1] })); });
    ecSel.addEventListener("change", function () { state.ecModel = ecSel.value; scheduleCalc(); });

    advDet.appendChild(el("div", { class: "row" }, [
      el("div", { style: "flex:0 0 auto" }, [el("label", { text: "A + B stock" }),
        el("label", { style: "display:flex;gap:6px;align-items:center;font-size:14px;color:var(--hb-fg)" }, [abToggle, "Concentrated A+B"])]),
      el("div", { class: "off" }, [el("label", { text: "Concentration factor (×)" }), cfInput])
    ]));
    advDet.appendChild(el("div", { class: "row" }, [
      el("div", {}, [el("label", { text: "Degree of freedom (let one element float)" }), dofSel]),
      el("div", {}, [el("label", { text: "EC model" }), ecSel])
    ]));
    secS.appendChild(advDet);
    // Select your salts — its own collapsed section (expandable to override the auto pick).
    var saltsDet = el("details", { class: "advcustom" });
    saltsDet.appendChild(el("summary", { text: "Select your salts" }));
    saltsDet.appendChild(secS);
    wrap.appendChild(saltsDet);

    // ================= RESULTS =================
    var secR = el("section", { class: "grad" });
    var perLabelEl = el("span", { class: "stepright" });
    function updatePerLabel() {
      var v = state.volume || 0;
      perLabelEl.textContent = "per " + fmt(v, 2) + " " + (v === 1 ? "litre" : "litres");
    }
    updatePerLabel();
    // "ⓘ" opens the rules-&-assumptions card: every judgement call the calculator
    // makes (priorities, acceptable ranges, optimizer rules, chemistry) in one place.
    function showAssumptions() {
      var existing = root.querySelector(".hb-copybox"); if (existing) existing.remove();
      var content = el("div", { class: "assume" });
      function group(title, items) {
        content.appendChild(el("h3", { text: title }));
        var ul = el("ul");
        items.forEach(function (t) { ul.appendChild(el("li", { text: t })); });
        content.appendChild(ul);
      }
      group("How weights are solved", [
        "For the salts you tick, the weights come from a weighted least-squares solve (the HydroBuddy method) across all targeted nutrients at once — not one salt at a time.",
        "An exact fit doesn't always exist (salts are chemically coupled). Unavoidable error is distributed by priority: P is held tightest; then N, K, Ca; then NH₄, Mg and micros; S, Na, Cl and Si are lowest.",
        "Sulfur is the designated \"slack\" nutrient — sulfate rides along with Mg/K/NH₄ salts, so leftover error is parked there on purpose."
      ]);
      group("When a number shows red", [
        "Red means outside the acceptable growing range for that element — not merely \"not exact\".",
        "Ranges: N, P, K, Ca −10% to +15% · NH₄ ±25% · Mg −15% to +20% · S −30% to +60% · micros −20% to +30%.",
        "Small deviations inside these ranges are normal and agronomically fine. Hover an Off value to see the range."
      ]);
      group("Suggest & Optimize", [
        "\"Suggest salts\" adds the standard grower toolbox for your targets (calcium nitrate, KNO₃, MKP, Epsom, ammonium nitrate, chelated micros…).",
        "\"Optimize my salts\" searches the whole catalogue — adding, removing and swapping salts — for the closest achievable fit with the fewest salts.",
        "The optimizer never auto-picks poorly soluble salts (carbonates, gypsum) and avoids ballast you didn't ask for (e.g. chloride or sodium). You can still tick any salt manually.",
        "Quick recipe = preset targets + Suggest + Optimize in one go."
      ]);
      group("Chemistry & units", [
        "Salt compositions assume the stated purity; liquid products are converted to mL by density (e.g. ammonium nitrate liquid, 18% N).",
        "Presets are stored in ppm; mmol/L conversion uses molar mass. Si can be entered as SiO₂ (× 0.4684).",
        "EC is estimated from ion conductivities with an activity correction — always verify with a meter.",
        "Source water counts as pure (all zeros) unless you enter its composition in step 2."
      ]);
      group("Privacy", [
        "Your targets are sent to Habitat's recipe engine to be solved and are never stored — no account needed, nothing is saved."
      ]);
      var box = el("div", { class: "hb-copybox" }, [
        el("div", { class: "hb-copycard" }, [
          el("div", { class: "hb-copyhd", text: "How this calculator decides — rules & assumptions" }),
          content,
          el("div", { style: "margin-top:14px;text-align:right" }, [
            el("button", { class: "primary", type: "button", text: "Done", onclick: function () { box.remove(); } })
          ])
        ])
      ]);
      box.addEventListener("click", function (e) { if (e.target === box) box.remove(); });
      // NB: must live inside .hb — the overlay styles are scoped ".hb .hb-copybox".
      wrap.appendChild(box);
    }
    var infoBtn = el("button", { class: "infobtn", type: "button", text: "i",
      title: "Rules & assumptions", "aria-label": "Rules and assumptions",
      onclick: function () { showAssumptions(); } });
    secR.appendChild(stepHeader("✓", "Your recipe", { filled: true,
      right: el("span", { style: "margin-left:auto;display:flex;gap:10px;align-items:center" }, [perLabelEl, infoBtn]) }));
    // Loading indicator — visible whenever a calculation round-trip is in
    // flight (wrap carries .hb-loading, see apiCalc). Pure CSS spinner.
    var calcSpin = el("div", { class: "calcspin" }, [
      el("span", { class: "spin" }),
      el("span", { text: "Calculating your recipe…" })
    ]);
    secR.appendChild(calcSpin);
    var warnBox = el("div");
    var metrics = el("div", { class: "metrics" });
    var recipeTbl = el("div");
    var achieveTbl = el("div");
    var ratioBox = el("div", { class: "hint" });
    var exportBtns = el("div", { class: "btns" }, [
      el("button", { class: "ghost", text: "Copy summary", onclick: function () { copySummary(); } }),
      el("button", { class: "ghost", text: "Download CSV", onclick: function () { downloadCSV(); } })
    ]);
    exportBtns.style.display = "none"; // shown only once there is a recipe to export
    secR.appendChild(warnBox); secR.appendChild(metrics);
    secR.appendChild(recipeTbl); secR.appendChild(achieveTbl);
    secR.appendChild(ratioBox); secR.appendChild(exportBtns);
    wrap.appendChild(secR);

    // ---- AI assistant (optional) — only renders when an endpoint is configured ----
    var assistCfg = (typeof window !== "undefined" && window.HABITAT_ASSISTANT) || {};
    var assistEndpoint = assistCfg.endpoint ||
      (host && host.getAttribute && host.getAttribute("data-assistant-endpoint")) || "";
    var assistMessages = [];
    if (assistEndpoint) buildAssistant();

    function assistantContext() {
      var ctx = { unit: state.unit, volumeLitres: volumeLiters(), targets: {}, achieved: {}, deviationPct: {}, sourceWater: {}, saltsUsed: [], estimatedEC: null };
      ELEMENTS.forEach(function (e) {
        var t = parseFloat(state.targets[e.key]); if (isFinite(t) && t > 0) ctx.targets[e.label] = t;
        var w = parseFloat(state.water[e.key]); if (isFinite(w) && w > 0) ctx.sourceWater[e.label] = w;
      });
      if (lastResult) {
        ctx.estimatedEC = round(lastResult.ec, 2);
        ELEMENTS.forEach(function (e) {
          var t = parseFloat(state.targets[e.key]); if (!isFinite(t) || t <= 0) return;
          var ach = ppmToDisplay(e, lastResult.achieved[e.key], state.unit, state.siAsSiO2);
          ctx.achieved[e.label] = round(ach, 3);
          ctx.deviationPct[e.label] = round(((ach - t) / t) * 100, 1);
        });
        lastResult.rows.filter(function (x) { return x.used; }).forEach(function (x) {
          ctx.saltsUsed.push({ salt: x.name, amount: amountStr(x) });
        });
      }
      return ctx;
    }

    function buildAssistant() {
      var sec = el("section", { class: "assist" });
      sec.appendChild(stepHeader("💬", "Ask the assistant"));
      sec.appendChild(el("div", { class: "chathint", text: "Ask about your recipe — deficiencies, adjustments, source water, EC/pH. Available to logged-in customers." }));
      var log = el("div", { class: "chatlog" });
      sec.appendChild(log);
      var input = el("textarea", { class: "chatinput", rows: "2", placeholder: "e.g. My sulfur is way over target — how do I fix that?" });
      var sendBtn = el("button", { class: "primary", type: "button", text: "Ask", onclick: function () { doAsk(); } });
      input.addEventListener("keydown", function (e) { if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) { e.preventDefault(); doAsk(); } });
      sec.appendChild(el("div", { class: "row" }, [
        el("div", {}, [input]),
        el("div", { style: "flex:0 0 auto" }, [el("label", { text: " " }), sendBtn])
      ]));
      wrap.appendChild(sec);

      function bubble(role, text) {
        var b = el("div", { class: "bubble " + role }); b.textContent = text;
        log.appendChild(b); log.scrollTop = log.scrollHeight; return b;
      }
      function doAsk() {
        var q = (input.value || "").trim(); if (!q) return;
        input.value = "";
        assistMessages.push({ role: "user", content: q });
        bubble("user", q);
        var pending = bubble("assistant", "…");
        sendBtn.disabled = true;
        fetch(assistEndpoint, {
          method: "POST", credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messages: assistMessages.slice(-16), context: assistantContext() })
        }).then(function (r) {
          if (r.status === 401 || r.status === 403) { pending.textContent = "Please log in to your account to use the assistant."; throw new Error("auth"); }
          if (!r.ok) throw new Error("http " + r.status);
          return r.json();
        }).then(function (j) {
          var reply = (j && j.reply) || "(no response)";
          pending.textContent = reply;
          assistMessages.push({ role: "assistant", content: reply });
        }).catch(function (e) {
          if (e.message !== "auth") pending.textContent = "Sorry — the assistant is unavailable right now. Please try again.";
        }).then(function () { sendBtn.disabled = false; });
      }
    }

    wrap.appendChild(el("div", { class: "foot", text: "Estimates for guidance — always verify EC/pH by measurement. Recipes are never saved — export what you need." }));

    function volumeLiters() { return state.volume || 0; }

    function calc() {
      if (!state.armed) return; // nothing runs until the visitor explicitly starts
      var volL = volumeLiters();
      var sel = Object.keys(state.selected);
      if (!volL || sel.length === 0) { lastResult = null; renderResults(null); return; }
      var t = targetsPpmMap(), any = false;
      ELEMENTS.forEach(function (e) { if (t[e.key] > 0) any = true; });
      if (!any) { lastResult = null; renderResults(null); return; }
      apiCalc().then(applyResponse);
    }

    var renderResults = function (res) {
      warnBox.innerHTML = ""; metrics.innerHTML = ""; recipeTbl.innerHTML = ""; achieveTbl.innerHTML = ""; ratioBox.innerHTML = "";
      exportBtns.style.display = (res && res.recipe && res.recipe.length) ? "flex" : "none";
      if (!res) {
        // Empty state: nothing has been calculated yet (or the inputs are
        // incomplete). The button is the explicit trigger — no backend call
        // happens on page load.
        recipeTbl.appendChild(el("div", { class: "hint", text: state.armed
          ? "Enter targets, a batch volume, and select at least one salt to see your recipe."
          : "Pick a crop in step 1 for a proven recipe — or set your own targets — then calculate." }));
        recipeTbl.appendChild(el("div", { class: "btns", style: "margin-top:12px" }, [
          el("button", { class: "primary", type: "button", text: "Calculate recipe", onclick: function () {
            var t = targetsPpmMap(), any = false;
            ELEMENTS.forEach(function (e) { if (t[e.key] > 0) any = true; });
            if (!any) { toast("Pick a crop in step 1 first, or enter your targets under “Customize targets”."); return; }
            state.armed = true;
            if (!Object.keys(state.selected).length) runOptimize(true); // pick + optimize salts server-side
            else calc();
          } })
        ]));
        return;
      }
      if (res.uncovered && res.uncovered.length) warnBox.appendChild(el("div", { class: "warn",
        text: "⚠ Recipe incomplete — no salt supplies " + res.uncovered.join(", ") + ". Add a source above or tap “Suggest salts”." }));
      (res.warnings || []).forEach(function (w) { warnBox.appendChild(el("div", { class: "warn", text: "⚠ " + w })); });
      if (res.unused && res.unused.length) warnBox.appendChild(el("div", { class: "hint",
        text: "Selected but not used by the solver: " + res.unused.join(", ") + ". If an element below is under target, remove these or choose a cleaner source (e.g. a chelated micro)." }));

      // metrics
      var usedRows = res.recipe;
      var r = ratios(res.achieved);
      // N:P:K tile is placed LAST so on mobile it wraps to its own row and the
      // wide "1 : 0.19 : 1.63" ratio gets full width instead of being cramped.
      metrics.appendChild(el("div", { class: "metric" }, [
        el("div", { class: "v", text: fmt(res.ec, 2) }), el("div", { class: "k", text: "Est. EC · mS/cm (" + (state.ecModel === "theo" ? "ionic" : "empirical") + ")" })]));
      metrics.appendChild(el("div", { class: "metric" }, [
        el("div", { class: "v", text: String(usedRows.length) }), el("div", { class: "k", text: "Salts used" })]));
      metrics.appendChild(el("div", { class: "metric" }, [
        el("div", { class: "v", text: r["N:P:K"].join(" : ") }), el("div", { class: "k", text: "N : P₂O₅ : K₂O ratio" })]));

      // A/B mixing guide — Tank A = calcium side + chelated micros, Tank B =
      // phosphate/sulfate/potassium. The side comes from the API (row.side).
      function tankCard(letter, title, sub, rows) {
        var total = rows.reduce(function (a, x) { return a + x.grams; }, 0);
        var body = [el("div", { class: "tk-h" }, [
          el("span", { class: "tk-badge", text: letter }),
          el("div", {}, [el("div", { class: "tk-t", text: "Tank " + letter + " — " + title }), el("div", { class: "tk-s", text: sub })])
        ])];
        rows.forEach(function (x) {
          var url = PRODUCT_LINKS[x.name];
          body.push(el("div", { class: "prod" }, [
            el("div", { class: "pi" }, [
              el("div", { class: "pn", text: x.name }),
              el("div", { class: "pg" }, [x.formula || "", url ? el("a", { class: "buy2", href: url, target: "_blank", rel: "noopener", text: " · Buy from Habitat ↗" }) : null].filter(Boolean))
            ]),
            el("div", { class: "amt2", text: amountStr(x) })
          ]));
        });
        body.push(el("div", { class: "tk-total" }, [el("span", { text: "Tank " + letter + " total" }), el("span", { text: amountStr({ grams: total, mL: null }) })]));
        return el("div", { class: "tank" }, body);
      }
      if (!usedRows.length) {
        recipeTbl.appendChild(el("div", { class: "hint", text: "No salts used — check your targets/selection." }));
      } else {
        var tankA = usedRows.filter(function (x) { return x.side === "A"; });
        var tankB = usedRows.filter(function (x) { return x.side !== "A"; });
        recipeTbl.appendChild(el("div", { class: "tanks" }, [
          tankCard("A", "Calcium side", "calcium nitrate · chelated micros", tankA),
          tankCard("B", "Nutrient side", "phosphate · sulfate · potassium", tankB)
        ]));
        recipeTbl.appendChild(el("div", { class: "infonote", text: "ℹ Keep tanks A and B as separate concentrates — calcium + sulfate/phosphate precipitate if combined. Dilute each into the reservoir separately." }));
      }
      if (state.abMode) recipeTbl.appendChild(el("div", { class: "hint",
        text: "A+B mode: weights are for the concentrated stock. Dose " + fmt(1000 / state.concFactor, 2) + " mL of each of stock A and B per litre of final solution." }));

      // achieved vs target — "bad" is per-element agronomic band, not a flat %;
      // rows grouped Macronutrients / Micronutrients like the target grids.
      function groupRow(label, cols) {
        return el("tr", {}, [el("td", { class: "grouprow", colspan: String(cols), text: label })]);
      }
      var t2 = el("table");
      var anyBad = false;
      t2.appendChild(el("tr", {}, [el("th", { text: "Element" }), el("th", { text: "Target" }), el("th", { text: "Achieved" }), el("th", { text: "Off" })]));
      var achGroups = { macro: [], micro: [] };
      ELEMENTS.forEach(function (e) {
        var tgt = parseFloat(state.targets[e.key]); if (!isFinite(tgt) || tgt <= 0) return;
        var ach = ppmToDisplay(e, res.achieved[e.key], state.unit, state.siAsSiO2);
        var off = tgt > 0 ? ((ach - tgt) / tgt) * 100 : 0;
        var band = bandFor(e.key);
        var bad = off < band[0] || off > band[1];
        if (bad) anyBad = true;
        // Sign follows the ROUNDED value: ±0.4% rounds to 0 and shows a plain "0%"
        // (previously the raw sign leaked through, giving a confusing "+0%").
        var offTxt = fmt(off, 0);
        achGroups[e.group].push(el("tr", {}, [
          el("td", { text: (e.key === "Si" && state.siAsSiO2) ? "Si (as SiO₂)" : e.label }),
          el("td", { text: fmt(tgt, 2) }), el("td", { text: fmt(ach, 2) }),
          el("td", { class: "offcell" + (bad ? " bad" : ""),
            title: "Acceptable range for " + e.label + ": " + band[0] + "% to +" + band[1] + "%",
            text: (offTxt === "0" ? "0%" : (off > 0 ? "+" : "") + offTxt + "%") })
        ]));
      });
      var splitEls = achGroups.macro.length && achGroups.micro.length;
      if (splitEls) t2.appendChild(groupRow("Macronutrients", 4));
      achGroups.macro.forEach(function (tr) { t2.appendChild(tr); });
      if (splitEls) t2.appendChild(groupRow("Micronutrients", 4));
      achGroups.micro.forEach(function (tr) { t2.appendChild(tr); });
      var achievedWrap = el("div", {}, [
        el("h2", { text: "Achieved vs target (" + UNITS[state.unit].label + ")" }),
        el("div", { class: "tbl" }, [t2])
      ]);
      if (anyBad) {
        var notes = res.explanations || [];
        var box = el("div", { class: "whybox" });
        box.appendChild(el("div", { class: "whyhead", text: "Why some numbers are off" }));
        if (notes.length) {
          var ul = el("ul");
          notes.forEach(function (n) { ul.appendChild(el("li", { text: n })); });
          box.appendChild(ul);
        } else {
          box.appendChild(el("div", { style: "font-size:13px", text: "The selected salts are chemically coupled — no exact fit exists for these targets." }));
        }
        box.appendChild(el("div", { class: "whyhint", text: "“✨ Optimize my salts” (step 3) searches the whole catalogue for the closest possible mix. Red only means outside the acceptable growing range — small deviations are normal and fine." }));
        achievedWrap.appendChild(box);
      }
      achieveTbl.appendChild(achievedWrap);

      ratioBox.innerHTML = "";
      ratioBox.appendChild(el("div", { text: "Ratios — N:P₂O₅:K₂O " + r["N:P:K"].join(":") + "   ·   K:Ca " + r["K:Ca"] +
        "   ·   Ca:Mg " + r["Ca:Mg"] + "   ·   NO₃:NH₄ " + r["NO₃:NH₄"] }));
      // Subtle electroneutrality read-out (the Dutch charge-balance check).
      if (res.ionBalance) {
        var ib = res.ionBalance, ok = ib.gapPct <= 10;
        ratioBox.appendChild(el("div", { style: "margin-top:4px" }, [
          "Ion balance — cations " + fmt(ib.cations, 1) + " / anions " + fmt(ib.anions, 1) + " meq·L⁻¹ ",
          el("span", { style: "color:" + (ok ? "var(--green)" : "var(--warn-fg)") + ";font-weight:700",
            title: ok ? "Cations and anions balance (electroneutral) — a valid solution" : "Cation/anion mismatch over 10% — check the recipe or an untracked ion",
            text: ok ? "✓ balanced" : "⚠ " + fmt(ib.gapPct, 0) + "% off" })
        ]));
      }
    };

    function summaryText() {
      if (!lastResult) return "";
      var lines = ["Habitat Advanced Nutrient Calculator — recipe", "Batch: " + state.volume + " litres", ""];
      lines.push("SALTS:");
      lastResult.recipe.forEach(function (x) {
        var amt = amountStr(x);
        lines.push("  " + x.name + " (Tank " + (x.side || "B") + "): " + amt);
      });
      lines.push("", "EC (est): " + fmt(lastResult.ec, 2) + " mS/cm", "");
      lines.push("ACHIEVED (" + UNITS[state.unit].label + "):");
      ELEMENTS.forEach(function (e) {
        var tgt = parseFloat(state.targets[e.key]); if (!isFinite(tgt) || tgt <= 0) return;
        var ach = ppmToDisplay(e, lastResult.achieved[e.key], state.unit, state.siAsSiO2);
        lines.push("  " + e.label + ": target " + fmt(tgt, 2) + " -> " + fmt(ach, 2));
      });
      return lines.join("\n");
    }
    function copySummary() {
      var txt = summaryText();
      if (!txt) { toast("Nothing to copy yet — calculate a recipe first."); return; }
      // Preferred API (works in secure contexts: https or localhost).
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(txt).then(
          function () { toast("✓ Recipe copied to clipboard"); },
          function () { legacyCopy(txt); }
        );
      } else { legacyCopy(txt); }
    }
    function legacyCopy(txt) {
      // execCommand path (older browsers / non-secure contexts)
      try {
        var ta = document.createElement("textarea");
        ta.value = txt; ta.style.position = "fixed"; ta.style.top = "0"; ta.style.left = "0"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.focus(); ta.select();
        try { ta.setSelectionRange(0, txt.length); } catch (e) {}
        var ok = document.execCommand && document.execCommand("copy");
        document.body.removeChild(ta);
        if (ok) { toast("✓ Recipe copied to clipboard"); return; }
      } catch (e) {}
      // Guaranteed fallback: show a selectable box the user can copy from.
      showCopyBox(txt);
    }
    function showCopyBox(txt) {
      var existing = root.querySelector(".hb-copybox"); if (existing) existing.remove();
      var ta = el("textarea", { class: "hb-copyarea", readonly: "readonly" }); ta.value = txt;
      var box = el("div", { class: "hb-copybox" }, [
        el("div", { class: "hb-copycard" }, [
          el("div", { class: "hb-copyhd", text: "Select all and press ⌘/Ctrl + C to copy" }),
          ta,
          el("button", { class: "primary", text: "Done", onclick: function () { box.remove(); } })
        ])
      ]);
      box.addEventListener("click", function (e) { if (e.target === box) box.remove(); });
      // NB: must live inside .hb — the overlay styles are scoped ".hb .hb-copybox".
      wrap.appendChild(box);
      ta.focus(); ta.select();
    }
    function downloadCSV() {
      if (!lastResult) { toast("Nothing to export yet — calculate a recipe first."); return; }
      var rows = [["Salt", "Formula", "Amount", "Unit", "Tank"]];
      lastResult.recipe.forEach(function (x) {
        rows.push([x.name, x.formula, x.mL != null ? fmt(x.mL, 3) : fmt(x.grams, 4), x.mL != null ? "mL" : "g", x.side || "B"]);
      });
      rows.push([]); rows.push(["Element", "Target(" + state.unit + ")", "Achieved(" + state.unit + ")", "Off%"]);
      ELEMENTS.forEach(function (e) {
        var tgt = parseFloat(state.targets[e.key]); if (!isFinite(tgt) || tgt <= 0) return;
        var ach = ppmToDisplay(e, lastResult.achieved[e.key], state.unit, state.siAsSiO2);
        rows.push([e.label, fmt(tgt, 3), fmt(ach, 3), fmt(((ach - tgt) / tgt) * 100, 1)]);
      });
      rows.push([]); rows.push(["EC (mS/cm)", fmt(lastResult.ec, 2)]);
      var csv = rows.map(function (r) { return r.map(function (c) { return '"' + String(c == null ? "" : c).replace(/"/g, '""') + '"'; }).join(","); }).join("\n");
      // Prepend a UTF-8 BOM so Excel reads the subscripts/degree signs correctly.
      var blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
      try {
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url; a.download = "habitat-recipe.csv"; a.style.display = "none";
        document.body.appendChild(a); a.click();
        setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
        toast("✓ CSV downloaded — check your Downloads folder");
      } catch (e) {
        toast("Couldn't auto-download — opening the CSV instead");
        try { window.open("data:text/csv;charset=utf-8," + encodeURIComponent("﻿" + csv)); } catch (e2) {}
      }
    }
    // small inline notice (used for coverage hints etc.)
    function flash(msg) {
      var f = el("div", { class: "warn", text: msg }); warnBox.innerHTML = ""; warnBox.appendChild(f);
      setTimeout(function () { if (f.parentNode) f.remove(); }, 1500);
    }
    // visible toast confirmation (bottom-center)
    var toastEl = el("div", { class: "hb-toast" }); wrap.appendChild(toastEl);
    var toastTimer = null;
    function toast(msg) {
      toastEl.textContent = msg; toastEl.classList.add("show");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove("show"); }, 2200);
    }

    // debounce — a little longer than the old local-solve version since every
    // calc is now a network round-trip through the App Proxy
    var timer = null;
    function scheduleCalc() { renderCoverage(); updateTargetInfo(); updatePerLabel(); clearTimeout(timer); timer = setTimeout(calc, 300); }

    // initial render — deliberately NO recipe auto-load and NO backend call:
    // most visits to the page are for the simple calculator above. Lettuce's
    // targets are pre-filled so "Calculate recipe" works immediately, but the
    // first API request only fires on an explicit action.
    unitPills(); renderTargets(); renderWater(); renderSalts(""); renderCoverage(); updateTargetInfo(); renderResults(null);
    var defIdx = HB_DATA.formulations.findIndex(function (f) { return f.name === (CROPS_QUICK[0] && CROPS_QUICK[0].recipe); });
    if (defIdx >= 0) {
      applyPreset(defIdx);
      if (cropBtns[0]) cropBtns[0].classList.add("on");
      recipeRef.innerHTML = "";
      recipeRef.appendChild(document.createTextNode(CROPS_QUICK[0].name + " → "));
      recipeRef.appendChild(el("b", { text: HB_DATA.formulations[defIdx].name }));
    }
  }

  /* ------------------------------------------------------------------ *
   *  Public API + auto-mount                                           *
   * ------------------------------------------------------------------ */
  var HydroBuddy = {
    mount: function (target) {
      var host = typeof target === "string" ? document.querySelector(target) : target;
      if (host) mount(host);
      return host;
    }
  };
  window.HydroBuddy = HydroBuddy;

  function autoMount() {
    var hosts = document.querySelectorAll("#hydrobuddy,[data-hydrobuddy]");
    if (hosts.length) hosts.forEach(function (h) { if (!h.__hbMounted) { h.__hbMounted = true; mount(h); } });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", autoMount);
  else autoMount();
})();
